<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<div class="row w-100">
    <mat-card class="simple-card mx-auto w-100">
        <mat-card-content>
            <div class="row">
                <div class="col-sm-12 d-flex justify-content-between" *ngIf="showHeader">
                    <h1>Reporte Actuación</h1>
                    <button
                        mat-flat-button class="custom-button-primary no-print"
                        [printTitle]='"Actuacion_"+(data?.rso_numeroatencion || "")+"_"+(rut | rutFormat)+"_"+today'
                        [useExistingCss]="true"
                        printSectionId="print-section" ngxPrint>
                            <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                            Descargar Resultado
                    </button>
                </div>

                <div class="col-sm-12 mx-auto" *ngIf="elements && elements.length > 0">
                    <div class="row p-5">
                        <ng-container *ngFor="let item of elements">
                            <div class="col-sm-12 col-md-4 col-lg-3 my-3 div-size">
                                <p class="color-secondary mb-0">{{item.titulo}}</p>
                                <p class="on-primary-fixed-variant mb-0">
                                    <strong>
                                        <ng-container [ngSwitch]="item.type">
                                            <ng-container *ngSwitchCase="'rut'">
                                                {{item.value ? (item.value | rutFormat) : ''}}
                                            </ng-container>
                                            <ng-container *ngSwitchCase="'fecha'">
                                                {{item.value ? (item.value | date: 'dd-MM-yyyy') : ''}}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                                {{item.value}}
                                            </ng-container>
                                        </ng-container>
                                    </strong>
                                </p>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
